module.exports = new Promise(resolve => {
        const remoteUrlWithVersion = window.BeekeeperCdn + '/forms/__bundles/webComponentsRemoteEntry.js';

        const script = document.createElement('script');
        script.src = remoteUrlWithVersion;
        script.onload = () => {
            const proxy = {
                get: (request) => window.FormsMobileWebV2.get(request),
                init: (...arg) => {
                    try {
                        return window.FormsMobileWebV2.init(...arg);
                    } catch(e) {
                        console.error('remote container already for FormsMobileWebV2 already initialized');
                    }
                }
            }

            resolve(proxy);
        }

        // Failure Handler
        script.onerror = () => {
            console.error('Failed to load remote: FormsMobileWebV2 at ' + remoteUrlWithVersion);
            
            // Resolve with a "Null Object" pattern so the host doesn't crash
            const fallbackProxy = {
                get: (request) => {
                    // Return a function that returns a component or module
                    // This allows the host's to still "resolve"
                    return Promise.resolve(() => ({
                        default: () => null
                    }));
                },
                init: () => {}
            };
            resolve(fallbackProxy);
        };

        document.head.appendChild(script);
    })
    ;